<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="listQuery.keyword"
            placeholder="变更类型/酒店ID/开始日期/结束日期"
            clearable
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="变更类型">
          <el-input
            v-model="listQuery.change_type"
            placeholder="精确查询，如HOTEL/PRODUCT"
            clearable
            style="width: 150px"
          />
        </el-form-item>
        <el-form-item label="丽呈酒店ID">
          <el-input
            v-model="listQuery.hotel_id"
            placeholder="精确查询"
            clearable
            style="width: 130px"
            type="number"
          />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      stripe
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="API账号ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.api_account_id }}
        </template>
      </el-table-column>

      <el-table-column label="变更类型" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.change_type === 'HOTEL'" type="primary" size="mini">酒店</el-tag>
          <el-tag v-else-if="scope.row.change_type === 'PRODUCT'" type="success" size="mini">产品</el-tag>
          <el-tag v-else-if="scope.row.change_type === 'INVENTORY'" type="warning" size="mini">库存</el-tag>
          <el-tag v-else-if="scope.row.change_type === 'PRICE'" type="danger" size="mini">价格</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="是否协议公司" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_company === 1" type="success" size="mini">是</el-tag>
          <el-tag v-else-if="scope.row.is_company === 0" type="info" size="mini">否</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="丽呈酒店ID" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>

      <el-table-column label="开始日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.start_date }}
        </template>
      </el-table-column>

      <el-table-column label="结束日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_date }}
        </template>
      </el-table-column>

      <el-table-column label="处理时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.handled_at }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="更新时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>

      <el-table-column label="其他" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="hasExtraData(scope.row)">...</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="变价变房推送详情"
      :visible.sync="dialogDetailVisible"
      width="800px"
      :close-on-click-modal="true"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="变更类型">
            <el-tag v-if="currentRow.change_type === 'HOTEL'" type="primary" size="mini">酒店</el-tag>
            <el-tag v-else-if="currentRow.change_type === 'PRODUCT'" type="success" size="mini">产品</el-tag>
            <el-tag v-else-if="currentRow.change_type === 'INVENTORY'" type="warning" size="mini">库存</el-tag>
            <el-tag v-else-if="currentRow.change_type === 'PRICE'" type="danger" size="mini">价格</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="是否协议公司">
            <el-tag v-if="currentRow.is_company === 1" type="success" size="mini">是</el-tag>
            <el-tag v-else-if="currentRow.is_company === 0" type="info" size="mini">否</el-tag>
            <span v-else>无</span>
          </el-descriptions-item>
          <el-descriptions-item label="丽呈酒店ID">
            {{ currentRow.hotel_id || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="房型ID列表">
            {{ currentRow.room_type_id_list || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="开始日期">
            {{ currentRow.start_date || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="结束日期">
            {{ currentRow.end_date || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="处理时间">
            {{ currentRow.handled_at || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">
            {{ currentRow.created_at || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="加密数据" :span="2">
            {{ currentRow.encrypted_data || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="解密JSON" :span="2">
            {{ currentRow.decrypted_json || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="原始请求" :span="2">
            {{ currentRow.raw_request || '无' }}
          </el-descriptions-item>
          <el-descriptions-item label="原始响应" :span="2">
            {{ currentRow.raw_response || '无' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      // 搜索参数
      listQuery: {
        page: 1,
        limit: 10,
        keyword: undefined,
        change_type: undefined,
        hotel_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      },
      // 日期范围
      dateRange: null,
      // 查看详情弹窗
      dialogDetailVisible: false,
      currentRow: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 判断是否有额外数据
    hasExtraData(row) {
      return row.encrypted_data || row.decrypted_json || row.room_type_id_list ||
        row.raw_request || row.raw_response
    },
    // 获取列表数据
    getList() {
      this.listLoading = true
      // 处理日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.start_at = this.dateRange[0]
        this.listQuery.end_at = this.dateRange[1]
      } else {
        this.listQuery.start_at = undefined
        this.listQuery.end_at = undefined
      }

      // 处理空值参数
      const params = {}
      Object.keys(this.listQuery).forEach((key) => {
        const val = this.listQuery[key]
        if (val !== '' && val !== undefined && val !== null) {
          params[key] = val
        }
      })

      request({
        url: '/api/backend/liCheng/hotel/pushChangeList',
        method: 'get',
        params: params,
      })
        .then((response) => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 点击查询按钮
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 点击重置按钮
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        keyword: undefined,
        change_type: undefined,
        hotel_id: undefined,
        start_at: undefined,
        end_at: undefined,
        sort: 'id',
        order: 'DESC',
      }
      this.dateRange = null
      this.getList()
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = Object.assign({}, row)
      this.dialogDetailVisible = true
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter-container {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 20px;
}
.detail-content {
  max-height: 500px;
  overflow: auto;
}
</style>
